<div class="modal-header">
    <h6 class="modal-title medium">{{'deleteMobileApp'|translate}}</h6>
    <button type="button" class="close" aria-label="Close" (click)="close(false)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="w-100 float-left p-4 modal-body advanced-mode">
    <h6> {{'sureWantToDelete'|translate}} </h6>
</div>
<div class="modal-footer">
    <button class="btn btn-secondary float-right" (click)="close(false)"> {{'close'|translate}}</button>
    <button class="btn btn-primary float-right" (click)="close(true)"> {{'delete'|translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/superAdmin/deleteMobileApplication.html